import { useEffect, useState } from "react";
import { atom, useAtomValue } from "jotai";

import { getText } from "shared/lib";

import {
  TreePropertyType,
  type TreeDescriptor,
  type TreePropertyDescriptor,
} from "@/components/treeModule/lib";

export const shouldShowValidationVar = atom<boolean>(false);

export type UseTreeDialogValidatorArguments<TP extends TreePropertyDescriptor> =
  {
    checker: (treeProperty: TP | undefined) => boolean;
    properties: TreeDescriptor["properties"];
    treePropertyType: TreePropertyType;
    id?: string;
  };

export function useTreeDialogValidator<TP extends TreePropertyDescriptor>({
  checker,
  properties,
  treePropertyType,
  id,
}: UseTreeDialogValidatorArguments<TP>) {
  const shouldShowValidation = useAtomValue(shouldShowValidationVar);

  const [isValid, setIsValid] = useState(true);
  const [messages, setMessages] = useState<Array<string>>([]);

  const treeProperty = properties.get(treePropertyType) as TP | undefined;

  useEffect(() => {
    if (!shouldShowValidation) {
      setIsValid(true);
      setMessages([]);
    }
  }, [shouldShowValidation]);

  useEffect(() => {
    if (checker(treeProperty)) {
      setIsValid(true);
      setMessages([]);
    } else {
      setIsValid(false);
      setMessages([getText("This information is required")]);
    }
  }, [checker, id, treeProperty, treePropertyType]);

  return { isValid, messages, shouldShowValidation };
}
